import { FC } from "react";
import { SentimentPositiveIcon, SentimentNegativeIcon, SentimentnNeutralIcon } from "../components/icons";



export const getSentimentIcon = (sentiment: number | null | undefined): FC => {
  if (sentiment === null || sentiment === undefined) {
    return SentimentnNeutralIcon;
  }

  if (sentiment <= 40) {
    return SentimentNegativeIcon;
  } else if (sentiment <= 70) {
    return SentimentnNeutralIcon;
  } else {
    return SentimentPositiveIcon;
  }
};

